module.exports = __webpack_public_path__ + "static/img/case5.43517bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/case5.png
// module id = +A9j
// module chunks = 1